import React from "react";
import PropTypes from "prop-types";
import { i18next } from "@translations/up/i18next";
import { Grid } from "semantic-ui-react";
import { ResourceTypeField as RDMResourceTypeField } from "@js/invenio_rdm_records";
import { ResourceTypeDescriptionField } from "./ResourceTypeDescriptionField";

export const ResourceTypeField = (props) => {
  let { record, ...restProps } = props;

  return (
    <Grid>
      <Grid.Column width="8">
        <RDMResourceTypeField
          helpText={i18next.t(
            "Selecting a resource type changes the fields displayed on the form."
          )}
          {...restProps}
        />
      </Grid.Column>
      <Grid.Column width="8">
        <ResourceTypeDescriptionField
          fieldPath="custom_fields.resource_type_description"
          record={record}
        />
      </Grid.Column>
    </Grid>
  );
};

ResourceTypeField.propTypes = {
  fieldPath: PropTypes.string.isRequired,
  record: PropTypes.object.isRequired,
  label: PropTypes.string,
  labelIcon: PropTypes.string,
  labelclassname: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      type_name: PropTypes.string,
      subtype_name: PropTypes.string,
      id: PropTypes.string,
    })
  ).isRequired,
  required: PropTypes.bool,
};

ResourceTypeField.defaultProps = {
  label: i18next.t("Resource type"),
  labelIcon: "tag",
  labelclassname: "field-label-class",
  required: false,
};
